import ReceiptIcon from '@mui/icons-material/Receipt';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import MovieIcon from '@mui/icons-material/Movie';
import InventoryIcon from '@mui/icons-material/Inventory';
import SchoolIcon from '@mui/icons-material/School';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TerrainIcon from '@mui/icons-material/Terrain';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalculateIcon from '@mui/icons-material/Calculate';

// ── Phase 7 navConfig — the single source of truth for section navigation ─────
// Consumed by BOTH the desktop icon rail (sideRail.js) and the mobile drawer
// (leftSideNav.js). Each item's `permission` is the key required to see it —
// the rail/drawer are generated from the permission set (no key → no icon).
// `section` indexes are stable and sparse: 3 (Job Report) and 4 (Project
// Manager) were retired 2026-07-09 — do not reuse their numbers.
// Session 58 extends these entries with per-section `topBar` configs.
// `navKey` maps to i18n/locales/<lang>.json's `nav.*` — consumers call
// t(`nav.${item.navKey}`) instead of the hardcoded `label` so a new section
// only needs a navKey + one line per locale file, nothing else.
export const NAV_ITEMS = [
  { label: 'Invoices',          navKey: 'invoices',          icon: <ReceiptIcon />,         section: 0, path: '/mis',              permission: 'mis:view' },
  { label: 'Customers',         navKey: 'customers',         icon: <PeopleAltIcon />,       section: 2, path: '/crm',              permission: 'crm:view' },
  { label: 'Files',             navKey: 'files',             icon: <InsertDriveFileIcon />, section: 1, path: '/files',            permission: 'files:view' },
  { label: 'Inventory',         navKey: 'inventory',         icon: <InventoryIcon />,       section: 5, path: '/inventory',        permission: 'inventory:view' },
  { label: 'People',            navKey: 'people',            icon: <Diversity2Icon />,      section: 6, path: '/users',            permission: 'users:view' },
  { label: 'Digital Marketing', navKey: 'digitalMarketing',  icon: <MovieIcon />,           section: 7, path: '/digitalMarketing', permission: 'digitalMarketing:view' },
  // No `permission` key — every authenticated user files their own reports
  // (same precedent as /myActivity), so the icon is unconditionally visible,
  // matching `!item.permission || can(item.permission)` in sideRail.js /
  // leftSideNav.js. "All reports" admin mode is gated inside the section
  // itself by jobReports:viewAll. Placed before Tutorials per explicit request.
  { label: 'Job Reports',       navKey: 'jobReports',        icon: <AssignmentIcon />,      section: 9, path: '/jobReports' },
  { label: 'Tutorials',         navKey: 'tutorials',         icon: <SchoolIcon />,          section: 8, path: '/tutorials',        permission: 'tutorials:view' },
  // Supply (Session 72) — stone-coupe sourcing/processing, separate from Inventory's
  // sellable-stock view but branch-scoped the same way.
  { label: 'Supply',            navKey: 'supply',            icon: <TerrainIcon />,         section: 10, path: '/supply',          permission: 'supply:view' },
];

// Entries that live beside the profile at the BOTTOM of the rail (and with the
// utilities in the mobile drawer), not in the main list. Kept as a separate
// array on purpose: main.js's "redirect to the first section you can open"
// walks NAV_ITEMS, and a utility must never become where someone lands.
// Report & Info is gated by info:view (default-deny) like every section.
export const FOOTER_NAV_ITEMS = [
  { label: 'Report & Info', navKey: 'info', icon: <InfoOutlinedIcon />, section: 11, path: '/info', permission: 'info:view' },
];

// The floating tools (tools/floatingTools/): not sections - no route, no permission key, available on every screen.
// On a desktop they are toggled by their shortcut key (F5 / F6); on a phone the drawer lists them under "Tools",
// after the sections. `key` is the name ToolsProvider knows them by; the label is t(labelKey).
export const TOOL_ITEMS = [
  { key: 'calendar',   labelKey: 'tools.calendar',   icon: <CalendarMonthIcon />, shortcut: 'F5' },
  { key: 'calculator', labelKey: 'tools.calculator', icon: <CalculateIcon />,     shortcut: 'F6' },
];

export const RAIL_WIDTH_COLLAPSED = 52;
export const RAIL_WIDTH_EXPANDED  = 208;
export const NAV_EXPANDED_KEY     = 'xms_navExpanded';
